import React, { Dispatch, SetStateAction } from 'react';
import { Control, FieldValues, UseFormSetValue } from 'react-hook-form';
import cn from 'classnames';

import { RadioButton, Select } from '@components/common';

import { TNameTitle } from '@interfaces/common/common';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EFormFields } from '@enums/kpi-api';
import { EGranularityValue } from '@enums/kpi-common';

import { automaticGranularitiesList } from '@components/Kpi/Parameters/constants';

import style from './Granularities.module.scss';

interface IGranularitiesProps {
	granularities: TSelectOptionType<EGranularityValue>[];
	automaticGranularity?: TNameTitle<EGranularityValue>;
	isAutomaticGranularity: boolean;
	setValue: UseFormSetValue<FieldValues>;
	granularity: TSelectOptionType<EGranularityValue>;
	control: Control;
	setIsDirty?: Dispatch<SetStateAction<boolean>>;
	manualId: string;
	automaticId: string;
	isRequired?: boolean;
}

const Granularities = (props: IGranularitiesProps) => {
	const {
		granularities,
		automaticGranularity,
		isAutomaticGranularity,
		setValue,
		control,
		setIsDirty,
		manualId,
		automaticId,
		isRequired = true,
	} = props;

	const onChangeGranularityType = (value: boolean) => {
		setValue('isAutomaticGranularity', value);

		if (value) {
			setValue('granularity', null);
		}

		if (setIsDirty) {
			setIsDirty(true);
		}
	};

	return (
		<div className={style.granularitiesWrapper}>
			<div className={cn(style.title, {
				[style.required]: isRequired,
			})}>
				Detail level
			</div>
			<div className={style.optionsWrapper}>
				<div className={style.granularityTypeWrapper}>
					<RadioButton
						checked={isAutomaticGranularity}
						id={automaticId}
						label='Automatic:'
						name={`${automaticId}-name`}
						onChange={onChangeGranularityType}
						value={true}
					/>
					{automaticGranularitiesList.map((item) => (
						<div
							key={item.value}
							className={cn(style.automaticGranularityItem, {
									[style.active]: automaticGranularity?.name === item.value,
								},
							)}
						>
							{item.label}
						</div>
					))
					}
				</div>
				<div className={style.granularityTypeWrapper}>
					<RadioButton
						checked={!isAutomaticGranularity}
						id={manualId}
						label='Manual:'
						name={`${manualId}-name`}
						onChange={onChangeGranularityType}
						value={false}
					/>
					<Select
						control={control}
						disabled={isAutomaticGranularity}
						menuPlacement='top'
						minHeight='28px'
						minWidth='150px'
						name={EFormFields.granularity}
						options={granularities}
						placeholder='Select granularity'
						required={!isAutomaticGranularity}
					/>
				</div>
			</div>
		</div>
	);
};

export default Granularities;
